import { useState } from '#app';
import { BrandDTO, BrandDTORes } from '~/restAPI/data-contracts';
import { useCatalogProvider } from '~/providers/catalog';

export const useAllBrands = () => useState<BrandDTORes[]>('useAllBrands', () => []);

async function loadAllBrands() {
  const allBrands = useAllBrands();

  if (allBrands.value?.length) return;

  const { fetchAllBrands } = useCatalogProvider();

  try {
    const res = await fetchAllBrands();

    allBrands.value = res;
  } catch (err) {
    console.error(err);
  }
}

function getBrandsByGroups(brands: BrandDTO[]) {
  const groups: Record<string, BrandDTO[]> = {};

  brands.forEach((brand) => {
    const char0 = brand.name!.charAt(0).toUpperCase();

    if (groups[char0]) {
      groups[char0].push(brand);
    } else {
      groups[char0] = [brand];
    }
  });

  return groups;
}

export function useBrands() {
  const allBrands = useAllBrands();

  return {
    allBrands,
    loadAllBrands,
    getBrandsByGroups,
  };
}
